<template>
    <div id="editor-container" style="height: 100%">
      <div id="bee-plugin-container">
      </div>
      <modal-container ref="modalContainer" />
    </div>
</template>

<script>
import ModalContainer from './ModalContainer.vue';

export default {
  name: 'EditorContainer',
  components: {
    ModalContainer
  }
};
</script>

<style scoped>
  #bee-plugin-container {
    height: 100%;
  }
</style>
